import { enzymeUniTestkitFactoryCreator } from '@wix/wix-ui-test-utils/enzyme';
import { default as InfiniteScrollTableUniDriver } from '../components/InfiniteScrollTable/InfiniteScrollTable.uni.driver';
import { InfiniteScrollCollectionListUniDriver } from '../components/InfiniteScrollCollectionList/InfiniteScrollCollectionList.uni.driver';
import PickerStandaloneUniDriver from '../components/PickerStandalone/PickerStandalone.uni.driver';
import { default as PickerModalUniDriver } from '../components/PickerModal/PickerModal.uni.driver';
import { CollectionViewsDropdownUniDriver } from '../components/CollectionViewsDropdown/CollectionViewsDropdown.uni.driver';
import { CollectionSaveViewModalUniDriver } from '../components/CollectionViewsDropdown/modals/SaveView/CollectionSaveViewModal.uni.driver';
import { CardsGridUniDriver } from '../components/Grid/CardsGrid.uni.driver';
import { TableGridSwitchUniDriver } from '../components/TableGridSwitch/TableGridSwitch.uni.driver';
import GridFoldersUniDriver from '../components/Grid/GridFolders.uni.driver';
import TableFoldersUniDriver from '../components/TableFolders/TableFolders.uni.driver';
import TableGridSwitchFoldersUniDriver from '../components/TableGridSwitchFolders/TableGridSwitchFolders.uni.driver';
import CustomFieldsWidgetUniDriver from '../components/CustomFieldsWidget/CustomFieldsWidget.uni.driver';
import { NestedTableUniDriver } from '../components/NestedTable/NestedTable.uni.driver';
import SkeletonCardUniDriver from '../components/SkeletonCard/SkeletonCard.uni.driver';
import ErrorCardUniDriver from '../components/ErrorCard/ErrorCard.uni.driver';
import EntityPageUniDriver from '../components/EntityPage/EntityPage.uni.driver';
import PageErrorStateUniDriver from '../components/PageErrorState/PageErrorState.uni.driver';

export const InfiniteScrollTableTestkit = enzymeUniTestkitFactoryCreator(
  InfiniteScrollTableUniDriver,
);

export const CardsGridTestkit =
  enzymeUniTestkitFactoryCreator(CardsGridUniDriver);

export const CustomFieldsWidgetTestkit = enzymeUniTestkitFactoryCreator(
  CustomFieldsWidgetUniDriver,
);

export const TableGridSwitchTestkit = enzymeUniTestkitFactoryCreator(
  TableGridSwitchUniDriver,
);

export const GridFoldersTestkit =
  enzymeUniTestkitFactoryCreator(GridFoldersUniDriver);
export const TableFoldersTestkit = enzymeUniTestkitFactoryCreator(
  TableFoldersUniDriver,
);
export const NestedTableTestkit =
  enzymeUniTestkitFactoryCreator(NestedTableUniDriver);

export const TableGridSwitchFoldersTestkit = enzymeUniTestkitFactoryCreator(
  TableGridSwitchFoldersUniDriver,
);

export const InfiniteScrollCollectionListTestkit =
  enzymeUniTestkitFactoryCreator(InfiniteScrollCollectionListUniDriver);

export const PickerStandaloneTestkit = enzymeUniTestkitFactoryCreator(
  PickerStandaloneUniDriver,
);

export const PickerModalTestkit =
  enzymeUniTestkitFactoryCreator(PickerModalUniDriver);

export const ViewsStandaloneTestkit = enzymeUniTestkitFactoryCreator(
  CollectionViewsDropdownUniDriver,
);

export const ViewsStandaloneSaveModalTestkit = enzymeUniTestkitFactoryCreator(
  CollectionSaveViewModalUniDriver,
);

export const EntityPageTestkit =
  enzymeUniTestkitFactoryCreator(EntityPageUniDriver);
export const SkeletonCardTestkit = enzymeUniTestkitFactoryCreator(
  SkeletonCardUniDriver,
);
export const ErrorCardTestkit =
  enzymeUniTestkitFactoryCreator(ErrorCardUniDriver);

export const PageErrorStateTestkit = enzymeUniTestkitFactoryCreator(
  PageErrorStateUniDriver,
);
